export enum DigitalActionAuthMockResult {
    AUTHORIZED = "AUTHORIZED",
    LOGIN_ERROR = "LOGIN_ERROR",
    IDENTITY_MISMATCH = "IDENTITY_MISMATCH",
    UNSPECIFIED_ERROR = "UNSPECIFIED_ERROR",
    TEMPORARY_FAILURE = "TEMPORARY_FAILURE",
}